import { create } from "zustand";
export const useOpportunitiesStore = create((set) => ({
  opportunities: null,
  opportunitiesCompanyDetail: null,
  opportunity: null,
  filter: {
    fulltext: "",
    invoice_date_ge: "",
    invoice_date_le: "",
    create_date_ge: "",
    create_date_le: "",
  },
  setFilter: (filter) => set({ filter }),
  setOpportunities: (opportunities) => set({ opportunities }),
  setOpportunitiesCompanyDetail: (opportunitiesCompanyDetail) =>
    set({ opportunitiesCompanyDetail }),
  setOpportunity: (opportunity) => set({ opportunity }),
}));
